/* LILY-GALLERY-TRACK v1  (10 sep 2026)
   Meet of bezoekers de fotogalerij op de productpagina gebruiken.
   Stuurt naar dezelfde first-party collector als de Shopify web pixel.

   Events:
     gallery_interact  - EENMAAL per paginaweergave, bij de eerste aanraking
                         van de galerij. price = index van de foto op dat moment.
     gallery_depth     - bij het verlaten van de pagina. price = hoogste
                         foto-index die de bezoeker heeft bereikt (0 = alleen
                         de eerste foto gezien).

   Verwijderen? Haal de regel met 'lily-gallery-track' uit
   snippets/product-gallery.liquid. Dit bestand mag dan blijven staan.
*/
(function () {
  'use strict';
  var ENDPOINT = 'https://pixel.178.104.12.53.sslip.io/pixel/collect';
  var SHOP = '4v0yyd-yz.myshopify.com';

  // UTM's DIRECT vastleggen: het thema herschrijft location.search naar ?variant=...
  // Navigation Timing bewaart de originele URL, dat is de betrouwbare bron.
  var UTM = (function () {
    function fromUrl(href) {
      try { var sp = new URL(href).searchParams;
        return { cp: sp.get('utm_campaign'), c: sp.get('utm_content') }; } catch (e) { return {}; }
    }
    var a = fromUrl(location.href);
    if (!a.cp) {
      try { var nav = (performance.getEntriesByType('navigation') || [])[0];
        if (nav && nav.name) a = fromUrl(nav.name); } catch (e) {}
    }
    var cp = a.cp || null, c = a.c || null;
    try {
      if (cp) localStorage.setItem('lgt_campaign', cp); else cp = localStorage.getItem('lgt_campaign');
      if (c) localStorage.setItem('lgt_content', c); else c = localStorage.getItem('lgt_content');
    } catch (e) {}
    return { utm_campaign: cp, utm_content: c };
  })();

  function utms() { return UTM; }

  function product() {
    var t = null, id = null;
    try {
      var el = document.querySelector('script[data-product-json]');
      if (el) { var p = JSON.parse(el.textContent); t = p.title || null; id = p.id != null ? String(p.id) : null; }
    } catch (e) {}
    if (!t) { var h = document.querySelector('h1'); if (h) t = (h.textContent || '').trim().slice(0, 120); }
    return { productTitle: t, productId: id };
  }


  // clientId: dezelfde waarde die Shopify's web pixel gebruikt (_shopify_y cookie),
  // zodat gallery-events te koppelen zijn aan add_to_cart en checkout.
  function clientId() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)_shopify_y=([^;]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }

  function send(name, index) {
    try {
      var u = utms(), p = product();
      var body = JSON.stringify({
        shop: SHOP, event: name, clientId: clientId(),
        utm_campaign: u.utm_campaign, utm_content: u.utm_content,
        url: location.href, productId: p.productId, productTitle: p.productTitle,
        price: (typeof index === 'number' ? index : null)
      });
      fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: body, keepalive: true });
    } catch (e) {}
  }

  function init() {
    var vp = document.querySelector('.product-gallery__viewport');
    if (!vp) return;                       // geen galerij op deze pagina
    if (window.__lgtOn) return;            // niet dubbel
    window.__lgtOn = true;

    var maxIdx = 0, fired = false, t = null;

    function idx() {
      var w = vp.clientWidth || 1;
      return Math.max(0, Math.round(vp.scrollLeft / w));
    }
    function touched(i) {
      if (typeof i === 'number' && i > maxIdx) maxIdx = i;
      if (!fired) { fired = true; send('gallery_interact', maxIdx); }
    }

    vp.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { touched(idx()); }, 140);
    }, { passive: true });

    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest ? e.target.closest(
        '.product-gallery__zoom, [class*="product-gallery__thumb"], [class*="product-gallery__dot"], [class*="thumbnail"], [class*="floating_dots"] button'
      ) : null;
      if (el) touched(idx());
    }, true);

    // samenvatting bij verlaten van de pagina
    var done = false;
    function summary() {
      if (done) return; done = true;
      if (fired) send('gallery_depth', maxIdx);
    }
    window.addEventListener('pagehide', summary);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') summary();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
